import { ref } from "vue";
import { captcha } from "./captcha";

/**
 * Возвращает состояние капчи и метод для ее проверки
 */
export const useCaptcha = () => {
    const isVerified = ref(false);

    captcha.on('is-verified-changed', (val) => {
        isVerified.value = val;
    });

    return {
        /** Проверить капчу/запустить проверку */
        check: () => captcha.check(),
        /** Принудительная проверка */
        checkForce: () => captcha.check(true),
        /** капча проверена и верифицирована */
        isVerified,
    }
}